var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginKakaoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sns/circle_kakao"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "vector",
    cx: 19.9998,
    cy: 20.2142,
    r: 18.3333,
    fill: "#FEE500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 10.2144C14.4769 10.2144 10 13.9203 10 18.4909C10 21.3334 11.7316 23.8393 14.3684 25.3298L13.2589 29.6721C13.1609 30.0558 13.5705 30.3616 13.885 30.1393L18.7482 26.7003C19.1586 26.7427 19.5757 26.7675 20.0001 26.7675C25.5228 26.7675 30 23.0617 30 18.4909C30 13.9203 25.5228 10.2144 20.0001 10.2144Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginKakaoIcon);
export default __webpack_public_path__ + "static/media/login_kakao_icon.b895a2e8dc67588e17f47742443ddb4c.svg";
export { ForwardRef as ReactComponent };